<template>
  <div class="head-wrap">
    <div class="content">
      <a :href="urlBase" style="display: flex;justify-content: center;align-items: center">
        <img src="../assets/images/top-logo.png" class="logo" alt="" />
        <img src="../assets/images/logo-text.png" class="logo" alt="" />
      </a>

      <div class="nav-links">
        <router-link to="/index" class="nav-link">首页</router-link>
        <router-link to="/all-live" class="nav-link">直播</router-link>
        <router-link to="/notice" class="nav-link">公告</router-link>
        <router-link to="/user" class="nav-link">个人中心</router-link>
      </div>

      <div class="search">
        <el-input placeholder="请输入关键词" prefix-icon="el-icon-search" v-model="keyWords" clearable @keyup.enter="handleSearch" @clear="handleSearch"></el-input>
        <el-button type="primary" round @click="handleSearch">搜索</el-button>
      </div>

      <div class="right-area">
        <div class="auth-buttons" v-if="!token">
          <router-link to="/login/register" class="register-btn">注册</router-link>
          <router-link to="/login" class="login-btn">立即登录</router-link>
        </div>

        <div class="user-info" v-else>
          <el-dropdown trigger="click" @command="handleUserClick">
            <span class="el-dropdown-link">
              <el-avatar :size="'small'" :src="userInfo.avatar" icon="el-icon-user-solid" style="margin-right: 5px"></el-avatar>
              {{ userInfo.nickname }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-user" command="user">会员中心</el-dropdown-item>
              <el-dropdown-item icon="el-icon-lock" command="logOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

<!--        <a href="https://work.weixin.qq.com/kfid/kfc9cf7803125222a78" class="customer-service">
          <img src="https://yike33.oss-cn-beijing.aliyuncs.com/0mkp8gjplndlmpl4yqgi.png" alt="客服" />
        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";
import { mapGetters } from "vuex";

export default {
  name: "PcShoppingHeader",

  data() {
    return {
      NavigationLeft: [
        {
          label: "首页",
          url: "/index",
        },
        {
          label: "关于我们",
          url: "/other/about-us",
        },
      ],
      NavigationRight: [
        /* {
          label: "客服中心",
          url: "/index",
        },*/
        {
          label: "商家中心",
          url: utils.getStoreBase(),
        },
      ],
      quickList: [
        { label: "认养土鸡", url: "/" },
        { label: "散养鸡", url: "/" },
        { label: "桃树", url: "/" },
        { label: "黑山猪", url: "/" },
        { label: "鸡蛋", url: "/" },
        { label: "土鸡蛋", url: "/" },
        { label: "脐橙", url: "/" },
        { label: "走地鸡", url: "/" },
      ],
      keyWords: "",
      urlBase: utils.getUrlBase(),
      localUserInfo: {},
    };
  },
  computed: {
    ...mapGetters(["userInfo", "token"]),
    displayUserInfo() {
      return this.userInfo && Object.keys(this.userInfo).length > 0
        ? this.userInfo
        : this.localUserInfo;
    },
    displayName() {
      const info = this.displayUserInfo;
      return info.nickname || info.nickName || info.username || "";
    }
  },

  mounted() {
    if (this.$route.query.keyWords) {
      this.keyWords = this.$route.query.keyWords;
    }
    this.initUserInfo();
  },

  methods: {
    initUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('mall_userInfo');
        if (userInfoStr) {
          this.localUserInfo = JSON.parse(userInfoStr);
        }
      } catch (error) {
        console.error('解析用户信息失败:', error);
      }

      // 如果Vuex中有token但userInfo为空，尝试获取用户信息
      if (this.token && (!this.userInfo || Object.keys(this.userInfo).length === 0)) {
        this.$store.dispatch("getUserInfo").then(() => {
          console.log('Header: 用户信息已更新');
        }).catch(() => {
          console.log('Header: 获取用户信息失败');
        });
      }
    },
    handleSearch() {
      const keyWords = this.keyWords.trim()
      if (!keyWords) {
        this.$message.warning('请输入搜索关键词')
        return
      }

      this.$router.push({
        path: '/search/index',
        query: { keyWords: keyWords }
      })
    },
    handleUserClick(key) {
      console.log(key);
      switch (key) {
        case "user":
          this.$router.push("/user");
          break;
        case "logOut":
          this.$store.dispatch("logOut");
          break;
      }
    },
  },
  watch: {
    $route() {
      this.initUserInfo();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-dropdown-menu {
  .qrcode-lg {
    width: 200px;
    height: 200px;
  }
}
.head-wrap {
  height: 100px;
  // border-bottom: 4px solid #42A747;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  font-size: 12px;

  a,
  .router-link {
    &:hover {
      color: #42a747 !important;
    }
  }

  .head-top {
    height: 44px;
    padding: 0 130px;
    line-height: 44px;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      .link {
        border-right: 2px solid #ccc;
        padding: 0 10px;

        &:last-child {
          border: none;
        }
      }
    }

    .right {
      display: block;
      .el-dropdown-link {
        cursor: pointer;
        color: #42a747;
        font-size: 16px;
      }

      .link {
        padding: 0 15px;
        border-right: 2px solid #ccc;
        &:last-child {
          border: none;
        }
      }
    }
  }

  .content {
    //padding: 0 130px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;

    @media (min-width: 1441px) {
      max-width: 1440px;
      margin: 0 auto;
      padding: 0;
    }

    @media (max-width: 1440px) {
      padding: 0 20px;
    }

    .logo:first-child {
      width: 60px;
      height: 50px;
      margin-right: 11px;
    }
    .logo:last-child {
      width: 107px;
      height: 46px;
    }

    // 新增的导航链接
    .nav-links {
      display: flex;
      align-items: center;
      margin-right: 40px;

      .nav-link {
        font-size: 16px;
        color: #333;
        text-decoration: none;
        padding: 0 40px;
        transition: color 0.3s;

        &:hover {
          color: #42a747;
        }

        &.router-link-exact-active {
          color: #42a747;
          font-weight: 500;
        }
      }
    }

    .search {
      width: 318px;
      height: 54px;
      border: 1px solid #39bf3e;
      border-radius: 27px;
      position: relative;
      margin-right: 40px;

      a,
      .router-link {
        color: #999 !important;
        padding: 0 10px;
        border-right: 1px solid #999;

        &:nth-last-child(1) {
          border: none;
        }

        &:hover {
          color: #42a747 !important;
        }
      }

      .el-input {
        width: 318px;
        height: 54px;

        ::v-deep .el-input__inner {
          height: 54px !important;
          border-radius: 27px;
          padding-right: 130px;
        }
      }

      .el-button {
        position: absolute;
        right: 0;
        top: 0;
        width: 125px;
        height: 54px;
        border-radius: 27px;
      }
    }

    // 右侧区域
    .right-area {
      display: flex;
      align-items: center;

      // 认证按钮区域
      .auth-buttons {
        display: flex;
        align-items: center;
        margin-right: 20px;

        .register-btn {
          display: inline-block;
          padding: 8px 20px;
          background-color: #F5F7FA;
          color: #61B865;
          border-radius: 4px;
          text-decoration: none;
          margin-right: 14px;
          font-size: 14px;
          transition: all 0.3s;

          &:hover {
            background-color: #e8eaed;
          }
        }

        .login-btn {
          display: inline-block;
          padding: 8px 20px;
          background-color: #4CAF4F;
          color: white;
          border-radius: 4px;
          text-decoration: none;
          font-size: 14px;
          transition: background-color 0.3s;

          &:hover {
            color: #fff!important;
            background-color: #3d8c40;
          }
        }
      }

      // 用户信息区域
      .user-info {
        margin-right: 20px;

        .el-dropdown-link {
          width: auto;
          max-width: 240px;
          height: 63px;
          display: flex;
          align-items: center;
          cursor: pointer;
          color: #333;
          font-size: 16px;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;

          ::v-deep .el-avatar{
            width: 50px!important;
            height: 50px!important;
            margin-right: 15px!important;
            img {
              width: 100%;
              height: 100%;
            }
          }

          &:hover {
            color: #42a747;
          }
        }
      }

      // 客服按钮
      .customer-service {
        display: inline-block;

        img {
          width: 40px;
          height: 40px;
          margin-left: 52px;
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
</style>

<style>
 .el-dropdown-menu__item {
   &:hover {
     background-color: unset !important;
   }
 }
</style>
